/**
 * Legal/Index Controller
 *
 * Displays a legal agreement that needs to be accepted
 */

// the constructor for this object
function LegalIndexController() { }

// the object
LegalIndexController.prototype = {
    constructor: LegalIndexController,
    
    // all unaccepted legal agreements
    legalAgreements: false,
    
    // the legal agreement id of the currently unaccepted
    legalAgreementId: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Legal Index Initialized');
    },
    
    // run the controller
    run: function()
    {    
        // get and populate the orders
        this._getUnacceptedAgreements();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Legal Index Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        $('#agree-btn').on('click', function() {
            PortalMain.LegalIndexController._acceptAgreement();
        });
    },
    
    // get the orders from the api
    _getUnacceptedAgreements: function()
    {
        // make the request
        var agreementsRequest = new PortalRequest;
        agreementsRequest.makeRequest(
            '/legal/get-unnaccepted-agreements',
            {},
            function(data) {
                
                if (data.length == 0) {
                    PortalHelper.sendToDashboard();
                    return;
                }
                
                // store the data for use after the agreement is accepted
                PortalMain.LegalIndexController.legalAgreements = data;
                PortalMain.LegalIndexController.legalAgreementId = data[0].legal_agreement_id;
                var agreement = data[0];
                
                // show product specific elements
                PortalMain.LegalIndexController._populateAgreement(agreement);
                    
                // set the headline
                PortalMain.LegalIndexController._setHeadline(agreement);
                    
                // set the breadcrumbs
                PortalMain.LegalIndexController._setBreadcrumbs(agreement);
            }
        );
    },
    
    // populate the agreement content
    _populateAgreement: function(agreement)
    {
        $('#legal-content').html(agreement.body);
        
        PortalHelper.enableButton('#agree-btn');
        PortalHelper.loadingOverlay('.content-col__content', false);
    },
    
    // set the headline according to the current product
    _setHeadline: function(agreement)
    {
        var headline = '';
        
        $('#headline').html(agreement.title);
    },
    
    // set the breadcrumbs according to the current product, and order
    _setBreadcrumbs: function(agreement)
    {
        $('.breadcrumbs .bc-legal').html(agreement.title);
        
        $('.breadcrumbs').removeClass('hidden');
    },
    
    // get the orders from the api
    _acceptAgreement: function()
    {
        PortalHelper.disableButton('#agree-btn');
        
        // make the request
        var agreementsRequest = new PortalRequest;
        agreementsRequest.makeRequest(
            '/legal/accept-agreement',
            {
                legalAgreementId: PortalMain.LegalIndexController.legalAgreementId
            },
            function(data) {
                if (PortalMain.LegalIndexController.legalAgreements.length > 1) {
                    window.location.reload();
                } else {
                    PortalHelper.sendToDashboard();
                }
            }
        );
    }
}